import { ComingSoonProvider } from "@/types/onboarding";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ComingSoonCardProps {
  provider: ComingSoonProvider;
}

const ComingSoonCard: React.FC<ComingSoonCardProps> = ({ provider }) => (
  <Card className="w-64 opacity-50 cursor-not-allowed">
    <CardContent className="p-6 text-center">
      <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
        <img
          src={provider.logo}
          alt={provider.name}
          className="w-full h-full object-contain"
        />
      </div>
      <CardTitle className="text-lg mb-4 text-gray-900">
        {provider.name}
      </CardTitle>
      <Button
        disabled
        className="w-full bg-gray-300 text-gray-500 cursor-not-allowed"
      >
        Coming Soon
      </Button>
    </CardContent>
  </Card>
);

export default ComingSoonCard;
